import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ProgressChart = ({ data, dataKey, title, color = "#2D6A4F" }) => {
  return (
    <div className="bg-card rounded-2xl shadow-sm border border-border p-6">
      <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
        {title}
      </h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E7E5E4" />
          <XAxis 
            dataKey="data" 
            stroke="#78716C"
            style={{ fontSize: '12px', fontFamily: 'IBM Plex Sans, sans-serif' }}
          />
          <YAxis 
            stroke="#78716C"
            style={{ fontSize: '12px', fontFamily: 'IBM Plex Sans, sans-serif' }}
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: '#FFFFFF',
              border: '1px solid #E7E5E4',
              borderRadius: '12px',
              fontFamily: 'IBM Plex Sans, sans-serif'
            }}
          />
          <Line 
            type="monotone" 
            dataKey={dataKey} 
            stroke={color} 
            strokeWidth={3}
            dot={{ fill: color, r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ProgressChart;